// Rótulos de las fotos de un equipo (18-oct-2026). Cada foto lleva un texto corto que dice qué es;
// se guarda por casilla: { antes, despues, extra: [] } (fotosRotulos del ítem).
export const ROTULOS_RAPIDOS = ['Antes · frente', 'Antes · atrás', 'Después · frente', 'Después · atrás', 'Falla', 'Repuesto'];

// Las fotos del equipo con su rótulo, en el orden de las casillas.
// Trabajos viejos (sin fotosRotulos): las dos primeras eran el antes y el después de siempre.
export function fotosConRotulo(it) {
    const r = it?.fotosRotulos;
    const viejo = !r;
    const lista = [
        { foto: it?.fotoAntes, rotulo: viejo ? 'Estado inicial' : r.antes },
        { foto: it?.fotoDespues, rotulo: viejo ? 'Estado final' : r.despues },
        ...(it?.fotosExtra || []).map((f, i) => ({ foto: f, rotulo: viejo ? null : (r.extra || [])[i] })),
    ].filter(x => x.foto);
    return lista.map((x, i) => ({ ...x, rotulo: x.rotulo || `Foto ${i + 1}` }));
}

// Rótulos que acompañan a las fotos ya subidas: si una falló al subir, su rótulo se va con ella.
export function rotulosTrasSubir(rotulos, extrasAntes, extrasSubidas) {
    // Sin rótulos igual va el objeto: así el PDF pone "Foto 1, 2…" y no el viejo "Estado inicial / final"
    if (!rotulos) return { antes: null, despues: null, extra: (extrasSubidas || []).filter(Boolean).map(() => null) };
    const extra = [];
    (extrasAntes || []).forEach((_, i) => { if (extrasSubidas[i]) extra.push((rotulos.extra || [])[i] || null); });
    return { antes: rotulos.antes || null, despues: rotulos.despues || null, extra };
}

// Rótulo de cada casilla para los PDF, en mayúsculas: [antes, después, extra 1, extra 2].
// Sin rótulos (trabajos viejos): ANTES / DESPUÉS / FOTO 3 / FOTO 4 como siempre.
export function rotulosPdf(it) {
    const r = it?.fotosRotulos;
    const base = r ? [r.antes, r.despues, ...(r.extra || [])] : ['Antes', 'Después'];
    return [0, 1, 2, 3].map(i => String(base[i] || `Foto ${i + 1}`).toUpperCase());
}
